window.addEventListener("load", function () {
  var nav = document.getElementById("navigation");
  if (nav) {
    var FILES = { vn: "index.html", en: "index-en.html", th: "index-th.html" };
    var input = document.getElementById("input-region");
    var current = input ? input.value : "vn";
    var activeLink = nav.querySelector(
      '.choose-language .region[data-region="' + current + '"]',
    );
    if (activeLink) activeLink.classList.add("active");
    nav.querySelectorAll(".region").forEach(function (a) {
      a.addEventListener("click", function (e) {
        e.preventDefault();
        var newLang = a.getAttribute("data-region");
        if (newLang === current) return;
        var d = new Date();
        d.setTime(d.getTime() + 30 * 864e5);
        document.cookie =
          "language=" + newLang + ";expires=" + d.toUTCString() + ";path=/";
        var href = a.getAttribute("href") || "";
        if (href.indexOf(".html") !== -1) {
          window.location.href = FILES[newLang] || "index.html";
          return;
        }
        var path = window.location.pathname;
        var hasLang =
          path === "/" + current || path.indexOf("/" + current + "/") === 0;
        var newPath = hasLang
          ? "/" + newLang + path.slice(current.length + 1)
          : "/" + newLang + path;
        window.location.href =
          newPath + window.location.search + window.location.hash;
      });
    });
  }

  var wrapper = document.getElementById("MS__wrapper");
  var audioSrc = wrapper ? wrapper.getAttribute("data-audio") : "";
  if (!audioSrc) return;

  var bgAudio = new Audio(audioSrc);
  bgAudio.loop = true;
  var hasInteracted = false;
  var manuallyPaused = false;

  function setPlayingClass(isPlaying) {
    document.querySelectorAll(".btn-music").forEach(function (btn) {
      btn.classList.toggle("is-playing", isPlaying);
    });
  }

  bgAudio.addEventListener("play", function () {
    setPlayingClass(true);
  });
  bgAudio.addEventListener("pause", function () {
    setPlayingClass(false);
  });

  function tryPlay() {
    bgAudio.play().catch(function () {});
  }

  function autoPlayHandler(e) {
    if (hasInteracted || e.target.closest(".btn-music")) return;
    hasInteracted = true;
    tryPlay();
    document.removeEventListener("click", autoPlayHandler);
  }
  document.addEventListener("click", autoPlayHandler);

  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".btn-music");
    if (!btn) return;
    hasInteracted = true;
    document.removeEventListener("click", autoPlayHandler);

    if (bgAudio.paused) {
      manuallyPaused = false;
      tryPlay();
    } else {
      manuallyPaused = true;
      bgAudio.pause();
    }
  });

  document.addEventListener("visibilitychange", function () {
    if (document.hidden) {
      if (!bgAudio.paused) bgAudio.pause();
    } else if (hasInteracted && !manuallyPaused && bgAudio.paused) {
      tryPlay();
    }
  });
});
